import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/balance")({
  component: () => <Outlet />,
  context: () => ({ permissions: "balance" }),
});
